import {
  HugeRollingOffer,
  MatchMastersRollingOffer
} from '@appcharge/shared-ui';
import { ERollingOfferInternalViewModel } from 'constants/enums';

export const mapRollingOffers: Record<ERollingOfferInternalViewModel, any> = {
  [ERollingOfferInternalViewModel.HUGE]: HugeRollingOffer,
  [ERollingOfferInternalViewModel.MATCH_MASTERS]: MatchMastersRollingOffer
};

export const mapViewModelRollingDisplayName: Record<
  ERollingOfferInternalViewModel,
  string
> = {
  [ERollingOfferInternalViewModel.HUGE]: 'Huge',
  [ERollingOfferInternalViewModel.MATCH_MASTERS]: 'Match Masters'
};
